@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@slider-label-spacing: 7px;

.button-container {
  display: inline-flex;
}

.quickship-popover {
  color: @quick-ship--popover--text-color;
  cursor: pointer;
  padding: 0 12px;
  position: relative;
  top: 4px;

  &.popover-open {
    color: @quick-ship--popover--open--text-color;
  }

  &.quickship-enabled {
    color: @quick-ship--popover--quickship-enabled--text-color;
  }
}

.quickship-icon {
  height: 16px;
  width: 10px;
}

.quickship-popover-content {
  width: 269px;
}

.header-row {
  height: 40px;
  width: 100%;
  background: @quick-ship--header-row--background-color;
  border-bottom: 1px solid @quick-ship--header-row--border-color;
  line-height: 22px;
  display: flex;
  justify-content: space-between;
  padding: 12px 12px 8px;
  align-items: center;
}

.popover-header-close {
  height: 12px;
  width: 12px;
  cursor: pointer;
}

.content,
.footer {
  font-size: 13px;
}

.content {
  padding: 16px;
}

.footer {
  border-top: 1px solid @quick-ship--footer--border-color;
  text-align: center;
  padding: 8px 0 12px;
}

.slider-row {
  display: flex;
  align-items: center;
}

.slider-styles {
  vertical-align: middle;
  margin-right: @slider-label-spacing;
}

.slider-label {
  padding-right: @slider-label-spacing;
}

.settings,
.settings-title {
  line-height: 20px;
}

.settings-title {
  font-weight: 500;
  padding-top: 8px;
}

.settings {
  display: grid;
  padding-left: 2px;
  grid-template-columns: 10px 1fr;
  align-items: center;
  column-gap: 8px;
}

.check {
  display: inline-block;
  justify-self: center;
  height: 9px;
  width: 9px;
  color: @quick-ship--check--text-color;
}

.setting-disabled {
  display: inline-block;
}
